export const CREATING_TEAM = "CREATING_TEAM";
export const UPDATING_TEAM = "UPDATING_TEAM";
export const TEAM_CREATED = "TEAM_CREATED";
export const TEAM_UPDATED = "TEAM_UPDATED";
export const ERROR_TEAM_CREATE = "ERROR_TEAM_CREATE";
export const ERROR_TEAM_UPDATE = "ERROR_TEAM_UPDATE";
export const UPDATED_RECENTLY = "UPDATED_RECENTLY";
export const SET_UPDATED_RECENTLY_TO_FALSE = "SET_UPDATED_RECENTLY_TO_FALSE";
